import { BREAKPOINT_MAP } from './constants';
export const generateSizesByBreakpoint = ({ fallback, xs, sm, md, lg }) => {
    const breakpoints = { lg, md, sm, xs };
    return Object.entries(breakpoints).reduce((sizes, [bp, value]) => {
        if (!value)
            return sizes;
        const [, max] = BREAKPOINT_MAP[bp];
        return sizes ? `(max-width: ${max}px) ${value}, ${sizes}` : `(max-width: ${max}px) ${value}`;
    }, fallback);
};
//# sourceMappingURL=generateSizesByBreakpoint.js.map